:host {
  display: block;
}

.swc-cookie-banner {
  z-index: 9999;
  max-width: 606px;
  margin: 10px;
  padding: 20px;

  display: flex;
  position: fixed;
  bottom: 0;

  font-size: 16px;
  line-height: 24px;
  font-family: var(--font-family), var(--base-font-01);
  color: var(--text-color);
  background-color: var(--background-color);

  @include breakpointMin('md') {
    margin: 30px;
    padding: 30px 40px;
  }

  p {
    margin: 0;
    a {
      color: var(--text-color);
    }
  }

  .close {
    margin-left: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;

    @include breakpointMin('md') {
      margin-left: 40px;
    }
  }

  &.hide {
    display: none;
  }
}
